import "./Companies.scss";
import "react-swipeable-list/dist/styles.css";

import { Col, Row } from "react-bootstrap";
import {
    LeadingActions,
    SwipeAction,
    SwipeableList,
    SwipeableListItem,
    TrailingActions,
} from "react-swipeable-list";
import { faAdd, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Alert from "react-bootstrap/Alert";
import AppCard from "../../commons/cards/AppCard";
import AppLoading from "../../commons/AppLoading";
import CompanyAPI from "./CompanyAPI";
import ConfirmModal from "../../commons/modal/ConfirmModal";
import FloatingButton from "../../commons/buttons/FloatingButton";
import FloatingVideoButton from "../../commons/buttons/FloatingVideoButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppConst from "../../commons/util/HallAppConst";
import HallAppContainer from "../../commons/containers/HallAppContainer";
import HallAppToast from "../../commons/HallAppToast";
import MenuTitle from "../../commons/menu/MenuTitle";
import ModalCompanyEditForm from "./components/ModalCompanyEditForm";
import PullToRefresh from "react-simple-pull-to-refresh";
import { fetchCompanies } from "../../redux/actions/companyAction";

function Companies() {
    const [isLoading, setIsLoading] = useState(true);
    const [showMoadlEdit, setShowMoadlEdit] = useState(false);
    const [company, setCompany] = useState(null);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false);

    const service = new CompanyAPI();
    const dispatch = useDispatch();
    const companies = useSelector((state) => state.company.companies);

    useEffect(() => {
        callGetEstablishments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const callGetEstablishments = useCallback(async () => {
        setIsLoading(true);
        await dispatch(fetchCompanies());
        setIsLoading(false);
    }, [dispatch]);

    const deleteEstablishments = async () => {
        if (!company?.id) return;
        setIsLoadingModalDelete(true);
        await service
            .deleteEstablishments(company.id)
            .then(async () => {
                HallAppToast.success();
                setShowModalDelete(false);
                await callGetEstablishments();
            })
            .catch(() => {
                HallAppToast.error(HallAppConst.GENERIC_ERROR);
            })
            .finally(() => {
                setIsLoadingModalDelete(false);
            });
    };

    const editAction = (item) => (
        <LeadingActions>
            <SwipeAction
                onClick={() => {
                    setCompany(item);
                    setShowMoadlEdit(true);
                }}
                aria-label="Editar estabelecimento"
            >
                <div className="swipe">
                    <div className="swipe swipe-edt">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                        <div>Editar</div>
                    </div>
                </div>
            </SwipeAction>
        </LeadingActions>
    );

    const deleteAction = (item) => (
        <TrailingActions>
            <SwipeAction
                destructive={false}
                onClick={() => {
                    setCompany(item);
                    setShowModalDelete(true);
                }}
                aria-label="Excluir estabelecimento"
            >
                <div className="swipe">
                    <div className="swipe swipe-dlt">
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                        <div>Excluir</div>
                    </div>
                </div>
            </SwipeAction>
        </TrailingActions>
    );

    const isEmpty = !isLoading && (!companies || companies.length === 0);

    return (
        <>
            <PullToRefresh onRefresh={callGetEstablishments}>
                <div className="container">
                    <Row style={{ margin: 0, width: "100%" }}>
                        {isLoading ? (
                            <Col xs={12}>
                                <HallAppContainer>
                                    <AppLoading />
                                </HallAppContainer>
                            </Col>
                        ) : (
                            <>

                                <MenuTitle title='Estabelecimentos' showArrowInfo={true} />


                                {isEmpty && (
                                    <Col xs={12}>
                                        <Alert variant="light" className="empty-state">
                                            Você ainda não adicionou um estabelecimento.
                                            <br />
                                            Toque no botão “+” para criar o primeiro.
                                        </Alert>
                                    </Col>
                                )}

                                {(companies || []).map((data) => (
                                    <Col xs={12} sm={6} md={4} lg={4} key={data.id} className="mb-3">
                                        <SwipeableList style={{ width: "100%" }}>
                                            <SwipeableListItem
                                                leadingActions={editAction(data)}
                                                trailingActions={deleteAction(data)}
                                                key={data.id}
                                                fullSwipe={false}
                                            >
                                                <div style={{ width: "100%" }}>
                                                    <AppCard backgroundColor="#FFFFFF">
                                                        <div className="company-card">
                                                            <div className="company-card__header">
                                                                <span className="company-card__unit">
                                                                    Unidade: <b>{data.unit || "-"}</b>
                                                                </span>
                                                            </div>
                                                            <div className="company-card__name">{data.name}</div>
                                                            <div className="company-card__address">
                                                                {data.street}, {data.number} - {data.city}/{data.state}
                                                            </div>
                                                        </div>
                                                    </AppCard>
                                                </div>
                                            </SwipeableListItem>
                                        </SwipeableList>
                                    </Col>
                                ))}
                            </>
                        )}
                    </Row>
                </div>
            </PullToRefresh>

            <FloatingButton
                icon={faAdd}
                aria-label="Adicionar novo estabelecimento"
                onClick={() => {
                    setShowMoadlEdit(true);
                    setCompany(null);
                }}
            />

            <ModalCompanyEditForm
                hasUpdated={() => callGetEstablishments(true)}
                show={showMoadlEdit}
                closeShow={() => setShowMoadlEdit(false)}
                company={company}
            />
             <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/M3O2ff-7nt0"} />

            <ConfirmModal
                type="danger"
                show={showModalDelete}
                title="Excluir"
                isLoading={isLoadingModalDelete}
                confirm={deleteEstablishments}
                closeModal={() => setShowModalDelete(false)}
            >
                Deseja remover o estabelecimento <span style={{ fontWeight: "bold" }}>{company?.name}</span>?
            </ConfirmModal>
        </>
    );
}

export default Companies;